import React from 'react'
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldError,
  RegisterOptions,
} from 'react-hook-form'
import { Checklist, ChecklistProps } from './Checklist'

type Props<T> = Omit<ChecklistProps<T>, 'value' | 'onChange'> & {
  control: Control
  name: string
  defaultValue?: ChecklistProps<T>['value']
  rules?: RegisterOptions
  error?: FieldError
}

export function ControlledChecklist<T>(props: Props<T>): React.ReactElement {
  const { control, name, defaultValue, rules, error, ...checklistProps } = props

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? []}
      rules={rules}
      render={({
        value,
        onChange,
      }: Omit<ControllerRenderProps, 'value'> & {
        value: ChecklistProps<T>['value']
      }) => (
        <Checklist
          {...checklistProps}
          value={value}
          onChange={(newValue) => onChange(newValue)}
        />
      )}
    />
  )
}
